import React from "react";
import ReactDOM from "react-dom";

import { loaderTranslation } from "data/loader/loaderTranslation";
import { useLanguagesContext } from "hooks/useContextAll";


const LoaderComponent = (props) => {
    const language = useLanguagesContext();

    return (
        <div className="loader" ref={props.loaderRef}>
            <h2>Y</h2>
            <div className="buttons-wrapper">
                <button onClick={() => {props.handleLoader(true)}}>
                    <ion-icon name="volume-high"></ion-icon>
                    <span>{loaderTranslation.withMusic[language.language]}</span>
                </button>
                <button onClick={() => {props.handleLoader(false)}}>
                    <ion-icon name="volume-mute"></ion-icon>
                    <span>{loaderTranslation.withoutMusic[language.language]}</span>
                </button>
            </div>
        </div>
    );
};

const Loader = (props) => {
    return (
        <>
            {ReactDOM.createPortal(
                <LoaderComponent
                    loaderRef={props.loaderRef}
                    handleLoader={props.handleLoader}
                />,
                document.getElementById("loader")
            )}
        </>
    );
};

export default Loader;
